<template>
  <div id="BasicInformation">
    <el-form label-width="300px">
      <el-form-item label="公司名称：">
        <div>{{ companyName }}</div>
      </el-form-item>
      <el-form-item label="数据访问序列号：">
        <div>{{ companySn }}</div>
        <div style="font-size: 12px;color:#A8A8A8">数据访问序列号是数据传输识别码，配合传输密码获取和云控组态平台进行数据交互的能力</div>
      </el-form-item>
      <el-form-item label="数据访问密码：">
        <el-button v-if="!companyPassWord" type="primary" :plain="true" @click="passwordShow">
          查看
        </el-button>
        <div v-if="companyPassWord">{{ companyPassWord }}</div>
        <el-button type="warning" :plain="true" @click="setPassword">
          重置
        </el-button>
        <div style="font-size: 12px;color:#A8A8A8">数据访问密码是数据传输校验密码，具有极高的安全性，切记勿把密码随意交给其他人，以防造成数据的泄露和破坏</div>
      </el-form-item>
      <el-form-item label="营业执照：">
        <img :src="businessLicense" style="width: 200px; height: 200px;" preview="0"/>
      </el-form-item>
    </el-form>
    <el-dialog title="查看数据访问密码" :visible.sync="showPassword" :modal-append-to-body="false" :append-to-body="true"
               custom-class="pcPersonCenter_dialog">
      <el-row>
        <el-form label-width="140px" label-position="left">
          <el-form-item label="公司绑定手机号" >
            <el-input v-model="companyTel" :disabled="true" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="短信验证码：">
            <el-input class="input" v-model="captcha">
              <template #append>
                <el-button type="primary" class="sendCodeBtn" v-if="!getCodeDisabled" @click="get_code">
                  {{getCaptcha}}
                </el-button>
                <el-button type="primary" class="sendCodeBtn" disabled v-else>{{ clock }}</el-button>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item label="图形验证码：" v-show="needImgVerifyCode">
            <div class="imgVerifyCode" style="">
              <el-input class="imgVerifyCode_input" v-model="imgVerifyCode">
                <img slot="suffix" id="imgVerifyCode" alt="点击更换" title="点击更换" @click="changeImg"/>
              </el-input>
            </div>
          </el-form-item>
        </el-form>
      </el-row>
      <span slot="footer" class="dialog-footer">
                  <el-button @click="showPassword=false" size="small">取 消</el-button>
                  <el-button type="primary" @click="getCompanyPassword" size="small">确定</el-button></span>
    </el-dialog>
    <SetDataPassword v-if="showSetPassword == true" :companyId="companyId" @returnBack="returnBack" @returnCompanyPassword="returnCompanyPassword"></SetDataPassword>

  </div>
</template>

<script>
import API from "../../../../config/api";
import SetDataPassword from "@/pages/userCenter/ChildComps/SetDataPassword";
import DOMAIN_PREFIX from "../../../../config/domainPrefix.js";
const AVATAR_PREFIX = DOMAIN_PREFIX.AVATAR_PREFIX
export default {
  name: "BasicInformation",
  //此处定义传入的数据
  props: {
    companyId: Number,
  },
  components:{
    SetDataPassword
  },
  data() {
    return {
      needImgVerifyCode: false,
      imgVerifyCode: '',
      companyName: '',
      companySn: '',  //序列号
      companyPassWord: null,
      showPassword: false, //查看密码对话框
      showSetPassword: false,//重置密码对话框
      companyTel: '',
      captcha: '', //验证码
      getCodeDisabled: false,
      getCaptcha: '获取验证码',
      clock: '',
      businessLicense:'',//营业执照
    }
  },
  mounted() {
    this.getCompanyInfoById();
    this.getCompanyTel(); //获取绑定手机号
  },
  methods: {
    //取消重置密码组件的展示
    returnBack(){
      this.showSetPassword = false;
    },
    //返回重置的数据密码
    returnCompanyPassword(password){
      this.companyPassWord = password;
    },
    //展示查看数据密码对话框
    passwordShow() {
      this.showPassword = true;
    },
    setPassword() {
      this.showSetPassword = true;
    },
    //获取公司绑定的电话号码
    getCompanyTel() {
      let header = {
        "Content-Type": "application/x-www-form-urlencoded"
      }
      let data = {
        companyId: this.companyId
      }
      this.$axiosRequest({
        url: API.getCompanyTel,
        method: 'POST',
        data: data,
        header: header,
        success: res => {
          this.companyTel = res.data.companyTelInfo.bindingTel;
        }
      });
    },
    // 获取验证码
    get_code() {
      let self = this;
      if (self.companyTel == '') {
        self.$message({type: 'warning', message: '手机号不能为空'});
      } else if (self.needImgVerifyCode && self.imgVerifyCode == '') {
        self.$message({type: 'warning', message: '图片验证码不应该为空'});
      } else {
        self.getCodeDisabled = true;
        let header = {
          "Content-Type": "application/x-www-form-urlencoded"
        }
        let data = {
          type: 3,
          phoneNumber: self.companyTel,
          imgVerifyCode: self.imgVerifyCode
        }
        this.$axiosRequest({
          url: API.sendCode,
          method: 'GET',
          data: data,
          header: header,
          success: res => {
            console.log(res)
            if (res.data == 0) {
              self.$message({type: 'success', message: '验证码发送成功'});
              self.testIfNeedImgVerifyCode();// 每次验证码发送成功后，测试下一次是否需要图片验证码
            } else if (res.data == 1) {
              self.$message({type: 'warning', message: '图片验证码输入不正确，请重新输入'});
            } else if (res.data == 2) {
              self.$message({type: 'warning', message: '请先输入图片验证码后才可获取短信验证码'});
            } else {
              self.$message({type: 'warning', message: '获取验证码失败，请稍后再试'});
            }
          }
        });
        let time = 59;
        self.clock = time + "s后重新发送";
        let cleartime = setInterval(() => {
          if (time <= 0) {
            self.clock = "重新获取";
            self.getCodeDisabled = false;
            clearInterval(cleartime);
            return false;
          }
          time -= 1;
          self.clock = time + "s后重新发送";
        }, 1000);
      }
    },
    changeImg() {
      let imgVerifyCode = document.getElementById("imgVerifyCode");
      imgVerifyCode.src = this.$axios.defaults.baseURL + "/message/getImgVerifyCode?time=" + Math.random(1000) + "&phoneNumber=" + this.companyTel;
      console.log("change: imgVerifyCode.src:", imgVerifyCode.src);
    },
    testIfNeedImgVerifyCode() {
      let self = this;
      if (!/^1[3|4|5|7|8][0-9]{9}$/.test(this.companyTel)) {
        return
      }
      if (!self.needImgVerifyCode) {// 如果needImgVerifyCode已经为true了，就不要再调用接口判断了，直接更换验证码图片
        let header = {
          "Content-Type": "application/x-www-form-urlencoded"
        }

        let data = {}
        this.$axiosRequest({
          url: API.testIfNeedImgVerifyCodeSend,
          method: 'POST',
          data: data,
          header: header,
          success: res => {
            console.log(res)
            if (res.data == 0) {
              self.needImgVerifyCode = true;
              self.changeImg();
            }
          }
        });
      } else {
        self.changeImg();
      }
    },
    //获取公司基本信息
    getCompanyInfoById() {
      let header = {
        "Content-Type": "application/x-www-form-urlencoded"
      }
      let data = {
        companyId: this.companyId
      }
      this.$axiosRequest({
        url: API.getCompanyInfoById,
        method: 'POST',
        data: data,
        header: header,
        success: res => {
          this.companyName = res.data.companyInfo.companyName;
          this.companySn = res.data.companyInfo.companySn;
          this.businessLicense = AVATAR_PREFIX + res.data.companyInfo.businessLicense+ this.companySuffix;
        }
      });
    },
    //获取公司密码
    getCompanyPassword() {
      let header = {
        "Content-Type": "application/x-www-form-urlencoded"
      }
      let data = {
        companyId: this.companyId,
        bindingTel: this.companyTel,
        smsVerifyCode: this.captcha
      }
      this.$axiosRequest({
        url: API.getCompanyPassword,
        method: 'POST',
        data: data,
        header: header,
        success: res => {
          if (res.data.companyPasswordInfo) {
            this.companyPassWord = res.data.companyPasswordInfo.companyPassword;
            this.showPassword = false;
          } else {
            this.$message({type: 'warning', message: res.data.error});
            this.showPassword = false;
          }
        }
      });
    }


  }
}
</script>

<style scoped lang="less">
#BasicInformation {
  .pcPersonCenter_dialog {
    padding: 0px 0px 20px 0px;

    &.el-dialog {
      width: 576px;
    }

    &.el-dialog__body {
      padding: 10px !important;
    }
  }

  .sendCodeBtn {
    float: right;
  }

  .imgVerifyCode {
    position: relative;
    margin: 0 auto;

    .imgVerifyCode_input {
      display: inline-block;
    }

    img {
      display: inline-block;
      height: 38px;
      border-radius: 0 4px 4px 0;
      border-left: 1px solid #C0C4CC;
      margin: 1px 0;
      left: 4px;
      position: relative;
    }
  }
}

</style>